import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent.service';
import { OneTrustConsentService } from 'src/app/services/cookie-consent/onetrust-consent.service';

/**
 * Bootstraps cookie consent: auto-grants in dev (when configured) or loads OneTrust CMP when a
 * market script id is set. Pendo still requires login in all environments.
 */
export function cookieConsentInitializer(): void {
  const consent = inject(CookieConsentService);

  if (environment.cookieConsent?.autoGrantConsent) {
    consent.grantConsent();
    return;
  }

  inject(OneTrustConsentService).initialize();
}
